export function getFinalTotalDollars(
  productPrice,
  discountPercent,
  discountAmount
) {
  const totalPrice = parseFloat(productPrice || 0);
  if (Number.isNaN(totalPrice)) return 0;

  let final = totalPrice;

  if (discountPercent && discountPercent !== "0.00") {
    const percent = parseFloat(discountPercent) || 0;
    if (percent > 0) {
      final = totalPrice - (totalPrice * percent) / 100;
    }
  } else {
    final = totalPrice - (parseFloat(discountAmount) || 0);
  }

  return Math.max(0, final);
}

export function getFinalTotalCents(
  productPrice,
  discountPercent,
  discountAmount
) {
  const dollars = getFinalTotalDollars(
    productPrice,
    discountPercent,
    discountAmount
  );
  return Math.max(0, Math.round(dollars * 100));
}
